export default __webpack_public_path__ + "static/media/MailIcon.86e2cb42.svg";